module.exports = __webpack_public_path__ + "img/kk.018b415f.png";